import { Box, Container, Paper } from "@mui/material";
import React, { FC, useEffect, useRef } from "react";
import SettingsForm, { SettingsFormSubmitHandler } from "./SettingsForm";
import InfoBoxGroup from "../base/InfoBoxGroup";
import InfoBox from "../base/InfoBox";
import { Business, InsertPhoto, PeopleAlt } from "@mui/icons-material";
import { useSelector, useDispatch } from "../../store";
import { useNavigate } from "react-router-dom";
import CompanySettings from "../../types/companySettings";
import Button from "../base/Button";
import Company from "../../types/company";
import { editCompany, saveNewCompany } from "../../slices/company";

interface Props {}

const Setup: FC<Props> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedCompany, status } = useSelector((store) => store.company);

  const formSubmitHandlerRef = useRef<SettingsFormSubmitHandler | null>(null);

  const handleSave = async (data: CompanySettings) => {
    const newCompany: Company = {
      id: 0,
      tenantId: "",
      settings: data,
    };
    if (selectedCompany?.id! > 0) {
      await dispatch(editCompany({ ...selectedCompany!, settings: data }));
    } else {
      await dispatch(saveNewCompany(newCompany!));
    }
    navigate("/apps");
  };

  const infoBoxes = [
    {
      text: "Enter your company details to set up your account. Update your contact email if needed.",
      icon: <Business fontSize="inherit" color="error" />,
    },
    {
      text: "After signing up, start your free trial and choose a product. You can add more users anytime.",
      icon: <PeopleAlt fontSize="inherit" color="primary" />,
    },
    {
      text: "Upload a logo for downloads and emails. If you don’t upload one, the SVPro logo will be used.",
      icon: <InsertPhoto fontSize="inherit" color="warning" />,
    },
  ];

  return (
    <Container sx={{ marginBottom: 8 }}>
      <InfoBoxGroup
        header=""
        content={infoBoxes.map((info, index) => {
          return <InfoBox key={index} text={info.text} icon={info.icon} />;
        })}
      />
      <Paper
        sx={{
          paddingY: 3,
          paddingX: { xs: 2, md: 5 },
          marginBottom: 5,
        }}
      >
        <SettingsForm onSave={handleSave} ref={formSubmitHandlerRef} />
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="flex-end"
          gap={2}
        >
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Button
              label="Save"
              variant={"contained"}
              color={"primary"}
              onClick={() => formSubmitHandlerRef.current?.()}
              disabled={status === "loading"}
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Setup;
